import { roleEmblem } from '~/game/agentCharacters'
import { agentAvatarUrl } from '~/game/agentTexture'
import { agentLookFor, useAgentLooks } from '~/state/agentLooks'

/**
 * The avatar rule (Malek, 30 Sep): an AI agent with no uploaded picture
 * (User.picture empty; a gravatar never counts) shows its character as its
 * avatar; an agent with a picture keeps it; people are unchanged. Where the
 * character shows, it says "AI" by itself: the ✦ and "AI agent" marks stay
 * only beside a picture.
 */
export const showsCharacter = (
  person: { isAgent: boolean; picture?: string | null } | null | undefined,
): boolean => Boolean(person?.isAgent && !person.picture)

/**
 * The agent's character, still, in an avatar box of `size` px: its look and
 * the role's emblem in the corner (from 20 px), with no disc behind.
 */
export function AgentCharacter({
  userId,
  size,
  style,
  title,
}: {
  userId: string
  size: number
  style?: React.CSSProperties
  title?: string
}) {
  // A string selector: zustand compares by value, and the URL is cached per look.
  const src = useAgentLooks((state) => {
    const look = agentLookFor(state, userId)
    return agentAvatarUrl(look, roleEmblem(look), size)
  })
  return (
    <img
      src={src}
      alt=""
      title={title}
      draggable={false}
      width={size}
      height={size}
      style={{ display: 'block', width: size, height: size, flex: '0 0 auto', ...style }}
    />
  )
}
